import React, { useState } from 'react';
import { Search, Radar, Loader2 } from 'lucide-react';
import axios from 'axios';
import { useAuth } from '../../store/AuthContext';
import { getApiUrl } from '../../services/api';

const ScoutPanel = ({ onResultsFound }) => {
  const { token } = useAuth();
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);

  const handleScout = async (e) => {
    e.preventDefault();
    if (!query) return;

    setLoading(true);
    try {
      const resp = await axios.post(`${getApiUrl()}/scout/overpass`, 
        { query }, 
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      onResultsFound(resp.data.elements);
    } catch (err) {
      alert('Mission Failed: Could not contact Overpass satellites.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      background: 'rgba(5, 7, 10, 0.95)',
      border: '1px solid #E27B58',
      padding: '15px',
      borderRadius: '4px',
      width: '280px',
      color: '#F0F0F0',
      boxShadow: '0 0 20px rgba(226, 123, 88, 0.2)'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
        <Radar size={18} color="#E27B58" />
        <h3 style={{ color: '#E27B58', fontSize: '0.85rem', textTransform: 'uppercase', margin: 0 }}>
          Overpass Scout
        </h3>
      </div>

      <form onSubmit={handleScout}>
        <div style={{ position: 'relative', marginBottom: '10px' }}>
          <input 
            type="text"
            className="nasa-input"
            placeholder="Search brand (e.g. KFC)"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            style={{ width: '100%', paddingRight: '35px', fontSize: '0.8rem' }}
          />
          <button 
            type="submit"
            disabled={loading}
            style={{
              position: 'absolute',
              right: '8px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'none',
              border: 'none',
              color: '#0B3D91',
              cursor: 'pointer'
            }}
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : <Search size={16} />}
          </button>
        </div>
        <p style={{ fontSize: '0.65rem', color: '#666', margin: 0 }}>
          Querying OpenStreetMap databases for real-time location data.
        </p>
      </form>
    </div>
  );
};

export default ScoutPanel;
